import AboutCapitalAcres from "./components/AboutCapitalAcres";
import AboutDeveloper from "./components/AboutDeveloper";
import BestQuotes from "./components/BestQuotes";
import Details from "./components/Details";
import FloorPlan from "./components/FloorPlan";
import Footer from "./components/Footer";
import Form from "./components/Form";
import Header from "./components/Header";
import Hero from "./components/Hero";
import LocationBenefits from "./components/LocationBenefits";
import NewForm from "./components/NewForm";
import Pricing from "./components/Pricing";
import Slider from "./components/Slider";

import StripSection from "./components/StripSection";

function App(){
  const project = "Ashar Merac Thane"
  const galleryImages = [
    {
      src: "images/g1.png",
      alt: "gallery1",
      title: "gallery1",
    },
    {
      src: "images/g2.png",
      alt: "gallery2",
      title: "gallery2",
    },
    {
      src: "images/g3.png",
      alt: "gallery3",
      title: "gallery3",
    }, {
      src: "images/g4.png",
      alt: "gallery1",
      title: "gallery1",
    }   
    // Add more amenities as needed
  ];
  const amenityImages = [
    {
      src: "images/a1.png",
      alt: "amenity1",
      title: "amenity1",
    },
    {
      src: "images/a2.png",
      alt: "amenity2",
      title: "amenity2",
    },
    {
      src: "images/a3.png",
      alt: "amenity3",
      title: "amenity3",
    }, {
      src: "images/a4.png",
      alt: "amenity1",
      title: "amenity1",
    }
    // Add more amenities as needed
  ];
  return(
    <>
    
    <div className="App">
      <Header  />
      <Hero />
      <StripSection/>
      <NewForm />
      <Details project={project} />
      <Pricing project={project} />
      <FloorPlan project={project} />
      <Slider project={project} title="Amenities" images={amenityImages} />
      <Slider project={project} title="Gallery" images={galleryImages} />
      <LocationBenefits project={project} />
      <AboutDeveloper project={project} />
      <AboutCapitalAcres project={project} />
      <BestQuotes />
      <Footer />
      <Form />
    </div>
    </>
  )
}

export default App;
